import { Component, Input, ViewChild, OnInit } from '@angular/core';
import { ThemeIconService } from 'app/services/theme-icon.service';
import { ToggleSlideComponent } from 'app/components/toggle-slide/toggle-slide.component';

@Component({
  selector: 'app-nav-container',
  templateUrl: './nav-container.component.html',
  standalone: false,
})
export class NavContainerComponent implements OnInit {
  @ViewChild('toggleSlide') toggleSlide!: ToggleSlideComponent;
  @Input() menu: any;
  @Input() supportMenu: any;
  @Input() userName: string;
  @Input() userMail: string;
  @Input() isUserLoggedIn: boolean;
  activeParent;

  theme: string;
  searchIsActive = false;

  constructor(private themeIconService: ThemeIconService) {}

  ngOnInit() {
    this.theme = this.themeIconService.getDefaultSetting();
    this.themeIconService.themeInfo.subscribe((theme) => {
      this.theme = theme;
    });
  }

  switchThemeMode(): void {
    this.theme = this.themeIconService.switchThemeMode(this.theme);
    if (this.toggleSlide) {
      this.toggleSlide.toggleHandler();
    }
  }

  openParentMenu(event: Event) {
    const target = event.target as HTMLElement;
    this.activeParent = target.closest('.support-container') as HTMLElement;
    if (this.activeParent) {
      this.activeParent.classList.toggle('-show-sub-menu');
    }
  }

  toggleMenu() {
    if (this.activeParent) {
      this.activeParent.classList.toggle('-show-sub-menu');
    }
  }

  onSearchActive(active: boolean) {
    this.searchIsActive = true;
  }
}